export function formatDate(date: any): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function addOneMonth(date: any): string {
  const newDate = new Date(date);
  newDate.setMonth(newDate.getMonth() + 1);

  return formatDate(newDate);
}

export function formatTime(date: any): string {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const formattedTime = `${hours}:${minutes}`;

  return formattedTime;
}

export function formatToISO8601(date: Date, time: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth()).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  const hours = time.getHours();
  const minutes = time.getMinutes();
  const seconds = time.getSeconds();
  const milliseconds = time.getMilliseconds();

  const combinedDate = new Date(
    Date.UTC(
      year,
      Number(month),
      Number(day),
      hours,
      minutes,
      seconds,
      milliseconds,
    ),
  );

  return combinedDate.toISOString();
}

export function formatDateToDDMMYYYY(dateString: string): string {
  if (dateString === null) {
    return 'не указано';
  }

  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
}

export function getDeliveryFormattedDate(isoDate: string): string {
  const date = new Date(isoDate);
  const dateOptions: any = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  const timeOptions: any = {
    hour: 'numeric',
    minute: 'numeric',
  };

  const formattedDate = date.toLocaleString('ru-RU', dateOptions);
  const startTime = date.toLocaleString('ru-RU', timeOptions);

  // Добавляем 1 час
  const endDate = new Date(date.getTime() + 60 * 60 * 1000);
  const endTime = endDate.toLocaleString('ru-RU', timeOptions);

  return `${formattedDate} с ${startTime} до ${endTime}`;
}

export function getFormattedDate(isoDate: string): string {
  const date = new Date(isoDate);
  const options: any = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };
  const formattedDate = date.toLocaleString('ru-RU', options);
  return formattedDate;
}
